import { FormControl, FormLabel, MenuItem, Select, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  buildRememberBrowserOptions,
  shouldShowRememberBrowserSelect,
} from 'utils/twoFactorSkipPolicy';

function TwoFactorRememberBrowserSelect({ twoFactorSkipPolicy, value, onChange }) {
  const { t } = useTranslation();

  const options = useMemo(
    () => buildRememberBrowserOptions(twoFactorSkipPolicy, t),
    [twoFactorSkipPolicy, t],
  );

  if (!shouldShowRememberBrowserSelect(twoFactorSkipPolicy) || options.length === 0) {
    return null;
  }

  const selectValue = value === null || value === undefined ? 'none' : String(value);

  return (
    <FormControl fullWidth sx={{ marginTop: 2, marginBottom: 1 }}>
      <FormLabel data-testid="two-factor-remember-label" sx={{ textAlign: 'left', marginBottom: 1 }}>
        {t('auth.login.two-factor-remember-label')}
      </FormLabel>
      <Select
        value={selectValue}
        onChange={(event) => {
          const nextValue = event.target.value;
          onChange(nextValue === 'none' ? null : Number(nextValue));
        }}
        data-testid="two-factor-remember-select"
        size="small"
        fullWidth
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      <Typography variant="caption" color="secondary" sx={{ mt: 0.75, display: 'block' }}>
        {t('auth.login.two-factor-remember-org-hint')}
      </Typography>
    </FormControl>
  );
}

export default TwoFactorRememberBrowserSelect;
